const TIME_SLOT_TYPES = {
  MORNING: 'morning',
  AFTERNOON: 'afternoon',
  EVENING: 'evening',
  ANYTIME: 'anytime',
  FIXED: 'fixed',
}

const STANDARD_TIME_SLOT_TYPES = [
  TIME_SLOT_TYPES.MORNING,
  TIME_SLOT_TYPES.AFTERNOON,
  TIME_SLOT_TYPES.EVENING,
]

export { STANDARD_TIME_SLOT_TYPES, TIME_SLOT_TYPES }
